/* global axios */

const getOverview = (accountId, params) =>
  axios.get(`/api/v2/accounts/${accountId}/ai_analytics/overview`, { params });

const getAuditStats = (accountId, params) =>
  axios.get(`/api/v2/accounts/${accountId}/ai_analytics/audit_stats`, { params });

export default { getOverview, getAuditStats };
